export const thermalPrintHTML = (d) => `
<div style="width:100%;display:flex;justify-content:center;">
  <div style="
    width:80mm;
    font-family:monospace;
    font-size:12px;
    line-height:1.4;
    text-align:center;
  ">

    <!-- HEADER -->
    <div style="font-weight:700;font-size:14px;">Shop Details</div>
    <div style="font-weight:700;font-size:15px;margin-top:4px;">
      ${d.shopName}
    </div>
    <div>Mobile : ${d.shopMobile}</div>

    <div style="margin-top:8px;font-size:18px;font-weight:700;">
      Amount : ₹${d.amount}
    </div>
    <div style="margin-top:6px;font-size:16px;font-weight:700;">
      Status : ${d.status}
    </div>

    <div style="border-top:1px dashed #999;margin:10px 0;"></div>

    <!-- TXN INFO -->
    <div style="text-align:left;padding:0 6px;">
      <div>Date   : ${d.date}</div>
      <div>${d.isIndoNepal ? "PIN" : "Txn ID"} : ${d.txnId}</div>
      ${d.isIndoNepal ? "" : `<div>Mode   : ${d.mode}</div>`}
    </div>

    <!-- INDO-NEPAL: Partner PIN + Customer ID -->
    ${d.isIndoNepal ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>PIN Details</b><br/>
        Partner PIN  : ${d.inPartnerPinNo || "—"}<br/>
        Customer ID  : ${d.inCustomerId   || "—"}
      </div>
    ` : ""}

    <!-- OPERATOR -->
    ${d.isOperatorTxn ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>Operator Details</b><br/>
        Operator : ${d.operatorName}<br/>
        ${d.consumerNumber ? `Consumer No : ${d.consumerNumber}` : ""}
      </div>
    ` : ""}

    <!-- AEPS CUSTOMER -->
    ${d.isAEPS ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>Customer Details</b><br/>
        ${d.aadhaar ? `Aadhaar : ${d.aadhaar}<br/>` : ""}
        ${d.aepsMobile ? `Mobile : ${d.aepsMobile}` : ""}
      </div>
    ` : ""}

    <!-- BILLER CUSTOMER -->
    ${d.isBillerTxn ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>Biller Details</b><br/>
        ${d.billerId ? `Biller ID : ${d.billerId}<br/>` : ""}
        ${d.billerConsumerNumber ? `Consumer No : ${d.billerConsumerNumber}` : ""}
      </div>
    ` : ""}

    <!-- NORMAL / INDO-NEPAL CUSTOMER -->
    ${!d.isOperatorTxn && !d.isAEPS && !d.isBillerTxn ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>${d.isIndoNepal ? "Sender" : "Customer"} Details</b><br/>
        ${d.customerName   || ""}<br/>
        ${d.customerMobile || ""}
      </div>
    ` : ""}

    <!-- BENEFICIARY / INDO-NEPAL RECEIVER -->
    ${!d.isOperatorTxn && !d.isBillerTxn ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>${d.isIndoNepal ? "Receiver" : "Beneficiary"} Details</b><br/>
        ${d.beneficiaryName    || ""}<br/>
        ${d.isIndoNepal
          ? `Partner PIN : ${d.inPartnerPinNo || ""}`
          : `${d.beneficiaryAccount || ""}<br/>${d.bankname || ""}`
        }
      </div>
    ` : ""}

    <!-- INDO-NEPAL: Amount breakdown -->
    ${d.isIndoNepal ? `
      <div style="border-top:1px dashed #999;margin:10px 0;"></div>
      <div style="text-align:left;padding:0 6px;">
        <b>Amount Details</b><br/>
        Send Amount    : INR ${d.inSendAmount}<br/>
        Service Charge : INR ${d.inServiceCharge}<br/>
        ${d.inPayAmountNPR  != null ? `Amount in NPR  : NPR ${d.inPayAmountNPR}<br/>` : ""}
        ${d.inExchangeRate  != null ? `Rate           : 1 INR = ${d.inExchangeRate} NPR` : ""}
      </div>
    ` : ""}

    <div style="height:12mm;"></div>
  </div>
</div>
`;





export const fullPrintHTML = (d) => `
<div style="
  font-family:Arial, sans-serif;
  font-size:18px;
  background:#f4f6f8;
  padding:12px;
">

  <div style="
    max-width:900px;
    margin:auto;
    background:#fff;
    border:2px solid #0A2A4F;
    border-radius:10px;
    padding:16px;
  ">

    <!-- ================= SHOP HEADER BOX ================= -->
    <div style="
      border:2px solid #0A2A4F;
      border-radius:8px;
      padding:12px;
      text-align:center;
      margin-bottom:12px;
    ">
      <div style="font-weight:700;">
        ${d.shopName}
      </div>
      <div style="margin-top:6px;">
        ${d.shopMobile}
      </div>
    </div>

    <!-- ================= CUSTOMER + BENEFICIARY ================= -->
    <div style="
      border:1px solid #e3e6ed;
      border-radius:8px;
      padding:12px;
      margin-bottom:12px;
      display:flex;
      justify-content:space-between;
      gap:10px;
      flex-wrap:wrap;
    ">

      <!-- CUSTOMER / SENDER -->
      <div style="flex:1;">
        ${d.isOperatorTxn ? `
          <div style="font-weight:600;">Operator</div>
          <div>${d.operatorName}</div>
          ${d.consumerNumber ? `<div>${d.consumerNumber}</div>` : ""}
        ` : d.isAEPS ? `
          <div style="font-weight:600;">Customer</div>
          ${d.aadhaar ? `<div>${d.aadhaar}</div>` : ""}
          ${d.aepsMobile ? `<div>${d.aepsMobile}</div>` : ""}
        ` : d.isBillerTxn ? `
          <div style="font-weight:600;">Biller</div>
          ${d.billerId ? `<div>Biller ID : ${d.billerId}</div>` : ""}
          ${d.billerConsumerNumber ? `<div>Consumer No : ${d.billerConsumerNumber}</div>` : ""}
        ` : `
          <div style="font-weight:600;">${d.isIndoNepal ? "Sender" : "Customer"}</div>
          <div>${d.customerName || ""}</div>
          <div>${d.customerMobile || ""}</div>
        `}
      </div>

      <!-- BENEFICIARY / RECEIVER -->
      ${!d.isOperatorTxn && !d.isBillerTxn ? `
        <div style="flex:1;">
          <div style="font-weight:600;">${d.isIndoNepal ? "Receiver" : "Beneficiary"}</div>
          <div style="font-weight:600;">${d.beneficiaryName || ""}</div>
          ${d.isIndoNepal
            ? `<div>Partner PIN : ${d.inPartnerPinNo || ""}</div>
               <div>Customer ID  : ${d.inCustomerId   || ""}</div>`
            : `<div>A/C : ${d.beneficiaryAccount || ""}</div>
               <div>${d.bankname || ""}</div>`
          }
        </div>
      ` : ""}

      <!-- AMOUNT -->
      <div style="
        min-width:160px;
        text-align:center;
        border-left:1px solid #ddd;
        padding-left:10px;
      ">
        <div style="font-weight:600;">${d.isIndoNepal ? "Send Amount" : "Amount"}</div>
        <div style="font-weight:700;font-size:26px;">
          ₹${d.amount}
        </div>
        ${d.isIndoNepal ? `
          <div style="font-size:14px;margin-top:4px;color:#555;">
            + ₹${d.inServiceCharge} charge
          </div>
          ${d.inPayAmountNPR != null ? `
          <div style="font-size:14px;font-weight:700;margin-top:4px;color:#0A2A4F;">
            NPR ${d.inPayAmountNPR}
          </div>` : ""}
          ${d.inExchangeRate != null ? `
          <div style="font-size:12px;color:#888;margin-top:2px;">
            1 INR = ${d.inExchangeRate} NPR
          </div>` : ""}
        ` : ""}
      </div>

    </div>

    <!-- ================= TXN TABLE ================= -->
    <div style="
      border:1px solid #e3e6ed;
      border-radius:8px;
      padding:12px;
      margin-bottom:12px;
    ">

      <table width="100%" cellspacing="0" cellpadding="8" style="font-size:18px;">

        <tr style="background:#f1f3f5;">
          <th align="left">${d.isIndoNepal ? "PIN" : "Txn ID"}</th>
          <th align="left">Date</th>
          ${d.isIndoNepal ? "" : `<th align="left">Mode</th>`}
          <th align="left">Status</th>
        </tr>

        <tr>
          <td>${d.txnId}</td>
          <td>${d.date}</td>
          ${d.isIndoNepal ? "" : `<td>${d.mode || "NA"}</td>`}
          <td style="font-weight:700;">${d.status}</td>
        </tr>

      </table>

    </div>

    <!-- ================= DISCLAIMER ================= -->
    <ul style="margin:0;padding-left:18px;font-size:16px;">
      <li style="margin-bottom:6px;">
        This is a system generated receipt hence does not require any signature.
      </li>
      <li>
        The customer is fully responsible for the accuracy of the details provided before the transaction.
      </li>
       <li>लेन-देन में हुई त्रुटि से संबंधित शिकायतों के निवारण में 24 से 48 कार्य घंटे लग सकते हैं।</li>
        <li>Resolution of complaints related to transaction errors may take 24 to 48 working hours.</li>
    </ul>

  </div>
</div>
`;


